// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

/* Start Gloabl Rule */

*{
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}


:root{
  --background-color : #f3f6f8 ;
  --main-color : #1958f7 ;
  --top-padding : 25px;
  --gray-color : #b1b2b3 ; 
  --main-transition : .3s;
  --message-btn : #009570 ;

}

/* End Gloabl Rule */


/* Start Modal */

.k-modal{
    width:280px;
    max-width: 100%;
    /* height: 420px; */
    /* height: 490px; */
    background-color: white;
    border-radius: 15px;
    padding: 13px 16px;
    border: none;
}

.k-modal .head{
  display: flex;
  justify-content: space-between;
}

.k-modal .head .right{
  color: #afb4ba;
  transition: var(--main-transition);
  height: 30px;
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}

.k-modal .head .right:hover{
  background-color: #e2e5e9  ;
  cursor: pointer;
}


.k-modal .head .right svg{
  cursor: pointer;
  font-size: 19px;
  font-weight: thin;
  transition: var(--main-transition);
}



.k-modal .head .left{
  font-size: 20px;
  padding-top: 5px;
}


.k-modal .head .left h3{
  letter-spacing: 1px;
  font-weight: 700;
}

.k-modal .head .left p{
  font-size: 14px;
  color:#4d5359;
}

.k-modal .body .write-message-con{
  margin: 12px 0px;
}

.k-modal .choose-image {
  width: 100%;
  background-color: #f8f9fb;
  border-radius: 8px;
  position: relative;
  cursor: pointer;
}

.k-modal .choose-image input {
  position: absolute;
  width: 100%;
  cursor: pointer;
  height: 100%;
  opacity: 0;
}

.k-modal .choose-image .center{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.k-modal .choose-image .center img{
  width: 35px;
  height: 35px;
  display: block;
}

.k-modal .choose-image .center .title{
  font-size: 14px;
  font-weight: 700;
}

.k-modal .choose-image .center .des{
  color: #838689;
  font-size: 12px;

}

.k-modal .body .write-message-con label{
  display: block;
  font-weight: 700;
  font-size: 15px;
  margin-left: 2px;
}

.k-modal .body .write-message-con .message-field{
  border: 1px solid #d5d3d3;
  width: 100%;
  border-radius: 7px;
  text-align: start;
  padding: 10px 12px;
  height: 110px;
  resize: none;
  margin-top: 4px;
}

.k-modal .body .write-message-con .message-field:focus{
  outline: none;
}

.k-modal .body .time-con{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}

.k-modal .body .time-con span{
  padding-top: 6px;
  font-weight: bold;
  font-size: 18px;
}

.k-modal .body .time-con .time-left , .k-modal .body .time-con .time-right{
  width:46%;
}

@media(max-width : 550px){
  .k-modal .body .time-con .time-left,.k-modal .body .time-con .time-right{
    width:100%;
  }
}

.k-modal .body .time-con .time-left p , .k-modal .body .time-con .time-right p {
  font-size: 13px;
  font-weight: 700;
}

.k-modal .body .time-con .time-left .time-field ,.k-modal .body .time-con .time-right .time-field {
  border: 1px solid #afb4ba;
  padding: 6px 7px;
  border-radius:5px;
  display: flex;
  align-items: center;
  width: 100%;
}

.k-modal .body .time-con .time-left .time-field input ,.k-modal .body .time-con .time-right .time-field input {
  width: 120px;
  max-width: 100%;
  border: none;
}

.k-modal .body .time-con .time-left .time-field svg , .k-modal .body .time-con .time-right .time-field svg{
  color:#4d5359;
  margin-right: 6px;
  font-size: 12px;
}

.k-modal .body .time-con .time-left .time-field input:focus , 
.k-modal .body .time-con .time-right .time-field input:focus{
  outline: none;
}

.k-modal .btn{
  margin-top: 20px;
}

.k-modal .btn button{
  display: block;
  width: 100%;
  padding: 8px 0px;
  background-color: var(--main-color);
  border: none;
  color: white;
  font-weight: 600;
  border-radius:6px ;
  cursor: pointer;
  transition: var(--main-transition);
}

.k-modal .btn button:hover{
  background-color:#5481f5;
}

.k-modal .body .choose-time {
  border: 1px solid #d5d3d3;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 12px;
  border-radius: 7px;
  margin-top: 13px;
  cursor: pointer;
  position: relative;



}

.k-modal .body .choose-time p {
  /* color: gray; */
  font-weight: 600;
  font-size: 14px;
}

.k-modal .body .choose-time svg{
  font-size: 12px;
}

.k-modal .body .choose-time .list-items{
  position: absolute;
  background-color: white;
  border: 1px solid #EEE;
  padding: 8px 10px;
  list-style: none;
  border-radius:7px;
  box-shadow: 1px 1px 1px #EEE;
  top: 119%;
  width: 100%;
  height: 150px;
  overflow-y: scroll;
  left: 50%;
  transform: translateX(-50%);
  transition: var(--main-transition);


  visibility: hidden;
  opacity: 0;
  transform: translate( -50%,-20px);

}

.k-modal .body .choose-time .list-items-show{
  visibility: visible;
  opacity: 1;
  transform: translate( -50%,0px);
}

.k-modal .body .choose-time .list-items li{
  padding: 3px 9px;
  margin-bottom: 4px;
  transition: var(--main-transition);
  border-radius: 7px;
}



.k-modal .body .choose-time .list-items li:hover{
  background-color: #EEE;
}

.k-modal .body .row{
  margin: 5px 0px;
}

.k-modal .body .row label{
  display: block;
  font-weight: bold;
  margin: 3px 0px;
}

.k-modal .body .row .input-row{
  width: 100%;
  border: 1px solid #EEE;
  border-radius: 7px;
  padding: 10px 22px;
  transition: var(--main-transition);
}

.k-modal .body .row .input-row:focus{
  outline: none;
  /* padding: 10px 23px; */
}

.k-modal .btn .add-token-btn {
  background-color:#009570;
}

.k-modal .btn .add-token-btn:hover{
  background-color:#05b287;

}

/* End Modal */


/* Start Loadding Comment Component */

.loadding-comment-con{
  width: 1020px;
  background-color: white;
  border-radius: 8px;
  height: 40px;
  display: flex;
  align-items: center;
  max-width: 100%;
  justify-content: space-between;
  padding: 8px;
}

.loadding-comment-con {
  margin-bottom: 8px;
}

.loadding-comment-con .loadding-sk{
  width: 120px;
  
}

/* Enda Loadding Comment Component */



 .main-pagination{
  display: flex;
  align-items: center;
  justify-content: space-between;
}

 .main-pagination .pagination-btn{
  width: 100px;
  margin: 10px 0px;
}

 .main-pagination .pagination-btn button{
  color: white;
  background-color: var(--main-color); 
  border-radius: 22px;
  padding: 10px 22px;
  cursor: pointer;
  border: none;
  transition: var(--main-transition);
}

.main-pagination .pagination-btn button:hover{
  opacity: .8;
}


`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":";;AAEA,sBAAsB;;AAEtB;EACE,UAAU;EACV,SAAS;EACT,sBAAsB;AACxB;;;AAGA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,oBAAoB;EACpB,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;;AAE1B;;AAEA,oBAAoB;;;AAGpB,gBAAgB;;AAEhB;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;;AAGA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,kCAAkC;AACpC;;;;AAIA;EACE,eAAe;EACf,gBAAgB;AAClB;;;AAGA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;;AAEjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,mCAAmC;EACnC,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;;;;AAIpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;EAC5B,SAAS;EACT,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,kCAAkC;;;EAGlC,kBAAkB;EAClB,UAAU;EACV,iCAAiC;;AAEnC;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,kBAAkB;AACpB;;;;AAIA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;;AAE1B;;AAEA,cAAc;;;AAGd,qCAAqC;;AAErC;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;;AAEd;;AAEA,oCAAoC;;;;CAInC;EACC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;CAEC;EACC,YAAY;EACZ,gBAAgB;AAClB;;CAEC;EACC,YAAY;EACZ,mCAAmC;EACnC,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,WAAW;AACb","sourcesContent":["\n\n/* Start Gloabl Rule */\n\n*{\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n}\n\n\n:root{\n  --background-color : #f3f6f8 ;\n  --main-color : #1958f7 ;\n  --top-padding : 25px;\n  --gray-color : #b1b2b3 ; \n  --main-transition : .3s;\n  --message-btn : #009570 ;\n\n}\n\n/* End Gloabl Rule */\n\n\n/* Start Modal */\n\n.k-modal{\n    width:280px;\n    max-width: 100%;\n    /* height: 420px; */\n    /* height: 490px; */\n    background-color: white;\n    border-radius: 15px;\n    padding: 13px 16px;\n    border: none;\n}\n\n.k-modal .head{\n  display: flex;\n  justify-content: space-between;\n}\n\n.k-modal .head .right{\n  color: #afb4ba;\n  transition: var(--main-transition);\n  height: 30px;\n  width: 30px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n}\n\n.k-modal .head .right:hover{\n  background-color: #e2e5e9  ;\n  cursor: pointer;\n}\n\n\n.k-modal .head .right svg{\n  cursor: pointer;\n  font-size: 19px;\n  font-weight: thin;\n  transition: var(--main-transition);\n}\n\n\n\n.k-modal .head .left{\n  font-size: 20px;\n  padding-top: 5px;\n}\n\n\n.k-modal .head .left h3{\n  letter-spacing: 1px;\n  font-weight: 700;\n}\n\n.k-modal .head .left p{\n  font-size: 14px;\n  color:#4d5359;\n}\n\n.k-modal .body .write-message-con{\n  margin: 12px 0px;\n}\n\n.k-modal .choose-image {\n  width: 100%;\n  background-color: #f8f9fb;\n  border-radius: 8px;\n  position: relative;\n  cursor: pointer;\n}\n\n.k-modal .choose-image input {\n  position: absolute;\n  width: 100%;\n  cursor: pointer;\n  height: 100%;\n  opacity: 0;\n}\n\n.k-modal .choose-image .center{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n\n.k-modal .choose-image .center img{\n  width: 35px;\n  height: 35px;\n  display: block;\n}\n\n.k-modal .choose-image .center .title{\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.k-modal .choose-image .center .des{\n  color: #838689;\n  font-size: 12px;\n\n}\n\n.k-modal .body .write-message-con label{\n  display: block;\n  font-weight: 700;\n  font-size: 15px;\n  margin-left: 2px;\n}\n\n.k-modal .body .write-message-con .message-field{\n  border: 1px solid #d5d3d3;\n  width: 100%;\n  border-radius: 7px;\n  text-align: start;\n  padding: 10px 12px;\n  height: 110px;\n  resize: none;\n  margin-top: 4px;\n}\n\n.k-modal .body .write-message-con .message-field:focus{\n  outline: none;\n}\n\n.k-modal .body .time-con{\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.k-modal .body .time-con span{\n  padding-top: 6px;\n  font-weight: bold;\n  font-size: 18px;\n}\n\n.k-modal .body .time-con .time-left , .k-modal .body .time-con .time-right{\n  width:46%;\n}\n\n@media(max-width : 550px){\n  .k-modal .body .time-con .time-left,.k-modal .body .time-con .time-right{\n    width:100%;\n  }\n}\n\n.k-modal .body .time-con .time-left p , .k-modal .body .time-con .time-right p {\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.k-modal .body .time-con .time-left .time-field ,.k-modal .body .time-con .time-right .time-field {\n  border: 1px solid #afb4ba;\n  padding: 6px 7px;\n  border-radius:5px;\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n.k-modal .body .time-con .time-left .time-field input ,.k-modal .body .time-con .time-right .time-field input {\n  width: 120px;\n  max-width: 100%;\n  border: none;\n}\n\n.k-modal .body .time-con .time-left .time-field svg , .k-modal .body .time-con .time-right .time-field svg{\n  color:#4d5359;\n  margin-right: 6px;\n  font-size: 12px;\n}\n\n.k-modal .body .time-con .time-left .time-field input:focus , \n.k-modal .body .time-con .time-right .time-field input:focus{\n  outline: none;\n}\n\n.k-modal .btn{\n  margin-top: 20px;\n}\n\n.k-modal .btn button{\n  display: block;\n  width: 100%;\n  padding: 8px 0px;\n  background-color: var(--main-color);\n  border: none;\n  color: white;\n  font-weight: 600;\n  border-radius:6px ;\n  cursor: pointer;\n  transition: var(--main-transition);\n}\n\n.k-modal .btn button:hover{\n  background-color:#5481f5;\n}\n\n.k-modal .body .choose-time {\n  border: 1px solid #d5d3d3;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 4px 12px;\n  border-radius: 7px;\n  margin-top: 13px;\n  cursor: pointer;\n  position: relative;\n\n\n\n}\n\n.k-modal .body .choose-time p {\n  /* color: gray; */\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.k-modal .body .choose-time svg{\n  font-size: 12px;\n}\n\n.k-modal .body .choose-time .list-items{\n  position: absolute;\n  background-color: white;\n  border: 1px solid #EEE;\n  padding: 8px 10px;\n  list-style: none;\n  border-radius:7px;\n  box-shadow: 1px 1px 1px #EEE;\n  top: 119%;\n  width: 100%;\n  height: 150px;\n  overflow-y: scroll;\n  left: 50%;\n  transform: translateX(-50%);\n  transition: var(--main-transition);\n\n\n  visibility: hidden;\n  opacity: 0;\n  transform: translate( -50%,-20px);\n\n}\n\n.k-modal .body .choose-time .list-items-show{\n  visibility: visible;\n  opacity: 1;\n  transform: translate( -50%,0px);\n}\n\n.k-modal .body .choose-time .list-items li{\n  padding: 3px 9px;\n  margin-bottom: 4px;\n  transition: var(--main-transition);\n  border-radius: 7px;\n}\n\n\n\n.k-modal .body .choose-time .list-items li:hover{\n  background-color: #EEE;\n}\n\n.k-modal .body .row{\n  margin: 5px 0px;\n}\n\n.k-modal .body .row label{\n  display: block;\n  font-weight: bold;\n  margin: 3px 0px;\n}\n\n.k-modal .body .row .input-row{\n  width: 100%;\n  border: 1px solid #EEE;\n  border-radius: 7px;\n  padding: 10px 22px;\n  transition: var(--main-transition);\n}\n\n.k-modal .body .row .input-row:focus{\n  outline: none;\n  /* padding: 10px 23px; */\n}\n\n.k-modal .btn .add-token-btn {\n  background-color:#009570;\n}\n\n.k-modal .btn .add-token-btn:hover{\n  background-color:#05b287;\n\n}\n\n/* End Modal */\n\n\n/* Start Loadding Comment Component */\n\n.loadding-comment-con{\n  width: 1020px;\n  background-color: white;\n  border-radius: 8px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  max-width: 100%;\n  justify-content: space-between;\n  padding: 8px;\n}\n\n.loadding-comment-con {\n  margin-bottom: 8px;\n}\n\n.loadding-comment-con .loadding-sk{\n  width: 120px;\n  \n}\n\n/* Enda Loadding Comment Component */\n\n\n\n .main-pagination{\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n .main-pagination .pagination-btn{\n  width: 100px;\n  margin: 10px 0px;\n}\n\n .main-pagination .pagination-btn button{\n  color: white;\n  background-color: var(--main-color); \n  border-radius: 22px;\n  padding: 10px 22px;\n  cursor: pointer;\n  border: none;\n  transition: var(--main-transition);\n}\n\n.main-pagination .pagination-btn button:hover{\n  opacity: .8;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
